<script>
/**
 * ESTE COMPONENTE CONTIENE LAS CELDAS DE LA TABLA 
 * @propiedad {String} align    Alineación [left|right|center]      Default left
 * @propiedad {String} title    Titulo de la celda para responsive  Default false
 * @propiedad {String} primary  Marca como negrita celda responsive
 * 
 * @ejemplo
 * <DatagridCell title='Nombre' align='right' primary>Texto</DatagridCell>
 */


    import {breakpoint, platform} from './MediaQuery.svelte'

    export let align='left';
    export let title=false;
    export let primary=false;
</script>

{#if $breakpoint=='xs' || $breakpoint=='sm' || $breakpoint=='md'}
    {#if primary===true}
        <tr>
            <td>
                {#if title!==false}
                    <small class='float-end'><span class="badge bg-light text-secondary">{title}</span></small>
                {/if}
                <strong><slot/></strong>
            </td>
        </tr>
    {:else}
        <tr>
            <td>
                {#if title!==false}
                    <small class='float-end'><span class="badge bg-light text-secondary">{title}</span></small>
                {/if}
                <slot/>
            </td>
        </tr>
    {/if}

{:else}
    <td
    class:text-start="{align === 'left'}"
    class:text-end="{align === 'right'}"
    class:text-center="{align === 'center'}"
    ><span class='{$$props.class}'><slot/></span></td>
{/if}


